<!-- 此组件作为全局组件，用于所有界面的底部展示 -->
<template>
  <div class="centerPos">
    <div class="myfooter">
      <div class="words">
        <div>
          <span class="cursor-pointer" @click="to('/aboutUs/none')">关于我们</span>
          <span>|</span>
          <span class="cursor-pointer" @click="to('/aboutUs/contact-box')">联系我们</span>
          <span>|</span>
          <span class="cursor-pointer" @click="openUrl('https://www.zhipin.com/gongsir/4bf2213be61e308d1nd509u_EQ~~.html?ka=company-jobs')">加入我们</span>
          <span>|</span>
          <span class="cursor-pointer" @click="openUrl('https://pro.voibook.com/html5/privacyPolicy.html')">隐私政策</span>
          <span>|</span>
          <span class="cursor-pointer" @click="setIsAuth(true)">权限</span>
          <p>开发者：广州音书科技有限公司</p>
          <p>音书app版本号：7.6.5</p>
          <p>
            友情链接：
            <a href="http://www.cdpf.org.cn/" target="_blank">中国残疾人联合会</a> |
            <a href="http://www.zglx.org.cn/" target="_blank">中国聋人协会</a> |
            <a href="http://www.cndcm.cn/" target="_blank">中国聋人网</a>
          </p>
        </div>
        <div>
          <p>广州音书科技有限公司 广州市番禺区南村镇番禺大道北383号</p>
          <p style="line-height:1.1;"><a href="http://beian.miit.gov.cn" target="_blank">Copyright© 2016-2024 All Rights Reserved. 粤ICP备16075128号-1</a></p>
          <p id="wechat">微信搜索“音书”公众号</p>
        </div>
      </div>
      <div class="code">
        <img src="../../assets/homePage/qrcode_for_gh_5a012438dd97_430.jpg"><br>
        <span style="margin:0px;">音书微信公众号</span>
      </div>
    </div>
    <el-drawer
      title="权限详情"
      :visible.sync="isAuth"
      direction="btt"
      :before-close="isAuth === false">
      <slot>
        <div class="authDrawer">
          <div
            class="authContent"
            v-for="(item, idx) in authList"
            :key="idx"
          >
            <div class="authTitle">{{item.title}}</div>
            <div class="authDesc">{{item.desc}}</div>
          </div>
        </div>
      </slot>
    </el-drawer>
  </div>
</template>

<script>
import './footer.css'
export default {
  name: 'myFooter',
  data () {
    return {
      isAuth: false,
      authList: [
        {
          title: '访问网络',
          desc: '访问网络连接,可能产生GPRS流量'
        },
        {
          title: '获取网络状态',
          desc: '获取网络信息状态,如当前的网络连接是否有效'
        },
        {
          title: '获取WiFi状态',
          desc: '获取当前WiFi接入的状态以及WLAN热点的信息'
        },
        {
          title: '改变网络状态',
          desc: '改变网络状态如是否能联网'
        },
        {
          title: '读写系统设置',
          desc: '允许读写系统设置项'
        },
        {
          title: '改变WiFi状态',
          desc: '改变WiFi状态'
        },
        {
          title: '访问定位额外命令',
          desc: '允许程序访问额外的定位提供者指令'
        },
        {
          title: '修改声音设置',
          desc: '修改声音设置信息'
        },
        {
          title: '唤醒锁定',
          desc: '允许程序在手机屏幕关闭后后台进程仍然运行'
        },
        {
          title: '显示系统窗口',
          desc: '显示系统窗口'
        },
        {
          title: '使用振动',
          desc: '允许振动'
        },
        {
          title: '禁用键盘锁',
          desc: '允许程序禁用键盘锁'
        },
        {
          title: '使用蓝牙',
          desc: '允许程序连接配对过的蓝牙设备'
        },
        {
          title: '拍照权限',
          desc: '允许访问摄像头进行拍照'
        },
        {
          title: '读取联系人',
          desc: '允许应用访问联系人通讯录信息'
        },
        {
          title: '写入联系人',
          desc: '写入联系人,但不可读取'
        },
        {
          title: '访问账户Gmail列表',
          desc: '访问GMail账户列表'
        },
        {
          title: '录音',
          desc: '录制声音通过手机或耳机的麦克'
        },
        {
          title: '读取电话状态',
          desc: '访问电话状态'
        },
        {
          title: '修改电话状态',
          desc: '修改电话状态,如飞行模式,但不包含替换系统拨号器界面'
        },
        {
          title: '拨打电话',
          desc: '允许程序从非系统拨号器里输入电话号码'
        },
        {
          title: '使用SIP视频',
          desc: '允许程序使用SIP视频服务'
        },
        {
          title: '写入外部存储',
          desc: '允许程序写入外部存储,如SD卡上写文件'
        },
        {
          title: '获取任务信息',
          desc: '允许程序获取当前或最近运行的应用'
        },
        {
          title: '挂载文件系统',
          desc: '挂载、反挂载外部文件系统'
        }
      ]
    }
  },
  methods: {
    openUrl (url) {
      window.open(url, '_blank')
    },
    to (path) {
      this.$router.push(path)
    },
    setIsAuth (bool) {
      this.isAuth = bool
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/FooterBar.vue